import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import { Spinner } from 'react-bootstrap';

const LoadingDashboardContent = ({ progress }) => {
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        // Simulating an async operation, like fetching data
        setTimeout(() => {
            setLoading(false); // After 3 seconds, set loading to false (content loaded)
        }, 3000);
    }, []);

    return (
        <>
            <Loader progress={progress} />
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" variant="info" />
            </div>
        </>
    );

};

export default LoadingDashboardContent;
